<div class="portal-login">
  <amplify-authenticator
    class="portal-login__authenticator"
    [services]="services"
    [hideSignUp]="true"
    [loginMechanisms]="['email']"
    [signUpAttributes]="['name', 'phone_number']"
  >
    <ng-template amplifySlot="sign-in-header">
      <div class="portal-login__header">
        <div class="portal-login__logo">
          <img src="/assets/logo.jpg" alt="Magaliesberg Pharmaceuticals" />
        </div>
        <h1 class="portal-login__title">Sign in to your account</h1>
        <p class="portal-login__terms">
          By signing in you have agreed to our
          <a routerLink="/tandcs">terms and conditions</a>.
        </p>
      </div>
    </ng-template>

    <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
      <div class="portal-authenticated">
        <router-outlet></router-outlet>
      </div>
    </ng-template>
  </amplify-authenticator>
</div>
